import { getAxiosInstance } from "../../np-rest/rest";
import { setDefaultLanguage } from "../../sc-translate/Translate/store/translateActions";
import { snackActions } from '../../sc-utilities/SnackBar';

export const fetchPrinters = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("/printers/list", { listAll: true, ...params });
            if (res.data && res.data.succeeded) {
                const printers = [];
                for (var printer of res.data.result.data) {
                    printers.push({ value: printer.PrinterID, displayValue: `${printer.Name} (${printer.PrinterType} / ${printer.ConnectionType})` });
                }
                return printers;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list printers"}`,
                    options: {
                        variant: 'warning'
                    }
                });

                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const fetchTypicalProblems = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("/typical_problems/list", { listAll: true, ...params });

            if (res.data && res.data.succeeded) {
                let typicalProblems = [];
                for (var tp of res.data.result.data) {
                    typicalProblems.push({
                        value: tp.TypicalProblemID,
                        TypicalProblemID: tp.TypicalProblemID,
                        label: `${tp.LongName}${tp.Code ? ` (${tp.Code})` : ""}`,
                        favorite: tp.favorite,
                        default: tp.default,
                        hotKey: tp.hotKey,
                        Code: `${tp.Code ? `${tp.Code}` : ""}`,
                    });
                }
                return typicalProblems;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list typical problems"}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const fetchTransportCollies = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("/palettes/transportColli/list", { listAll: true, ...params });
            if (res.data && res.data.succeeded) {
                let transportCollies = [];
                for (var transportColli of res.data.result.data) {
                    transportCollies.push({
                        value: transportColli.TransportColliID,
                        label: `${transportColli.Name} (${transportColli.TransportColliInventoryID})`
                    });
                }
                return transportCollies;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list transport collies "}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const fetchCollies = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("colli/list", { listAll: true, ...params });
            if (res.data && res.data.succeeded) {
                let collies = [];
                for (var colli of res.data.result.data) {
                    collies.push({
                        value: colli.ColliID,
                        label: `${colli.Name} (${colli.ColliInventoryID})`
                    });
                }
                return collies;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list collies "}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const fetchFavoriteHotKeys = params => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post("/users/list-favorite-hot-keys", { ...params });
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            else {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list favorite hot keys"}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

export const saveSettings = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        if (data["DefaultLanguage"]) {
            dispatch(setDefaultLanguage(data["DefaultLanguage"]));
        }
        try {
            await rest.post("/users/update-settings", data);
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message}`,
                options: {
                    variant: 'error'
                }
            });
            return [];
        }
    };
};

const changeLoggedUserStart = () => {
    return {
        type: "CORE|CHANGE_LOGGED_USER_INFORMATION_START"
    };
};

const changeLoggedUserSuccess = result => {
    return {
        type: "CORE|CHANGE_LOGGED_USER_INFORMATION_SUCCESS",
        user: result
    };
};

const changeLoggedUserFail = error => {
    return {
        type: "CORE|CHANGE_LOGGED_USER_INFORMATION_FAIL",
        error: error
    };
};

// Fetch Pendrive action creators
export const saveUser = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(changeLoggedUserStart());
        try {
            let res = await rest.post("/users/my-profile/save", data);
            if (res.data.succeeded) {
                const result = res.data.result.data;
                dispatch(changeLoggedUserSuccess(result));
                snackActions.snackBar({
                    message: `${res.data.message}`,
                    options: {
                        variant: "success"
                    }
                })
            }
            else {
                dispatch(changeLoggedUserFail(res.error));

                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot list delivery notes  "}`,
                    options: {
                        variant: 'warning'
                    }
                });
                return [];
            }
        } catch (err) {
            dispatch(changeLoggedUserFail(err));
            snackActions.snackBar({
                message: `${err.message}`,
                options: {
                    variant: "error"
                }
            })
        }
    };
};


export const fetchAddresses = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let listRes = await rest.post("/address/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                return { data: Array.isArray(listRes.data.result.data) && listRes.data.result.data.length > 0 ? listRes.data.result.data[0] : null };
            }

            snackActions.snackBar({
                message: `${listRes && listRes.data ? listRes.data.message : "Cannot fetch addresses."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: null };
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch addresses."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: null }
        }
    }
};

export const fetchAuthenticationEnableDisable = (data) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            const result = await rest.post("/users/enable-or-disable-auth", data);
            if (result.data && result.data.succeeded) {
                snackActions.snackBar({
                    message: result.data.message? result.data.message : `Successfully updated user settings.`,
                    options: {
                        variant: 'success'
                    }
                });
                dispatch({type: "CORE|AUTH|ENABLE_OR_DISABLE_AUTH"});
                return result.data.result.data;
            }
            snackActions.snackBar({
                message: `${result.data.message? result.data.message : "Cannot update user settings"}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot update user settings"}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}

export const fetchGenerateOTPAuth = (data) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const result = await rest.post("/users/generate-otp-auth", data);
            if (result.data && result.data.succeeded) {
                snackActions.snackBar({
                    message: result.data.message? result.data.message : "Successfully generated OTP auth",
                    options: {
                        variant: 'success'
                    }
                });
                return result.data.result.data;
            }
            snackActions.snackBar({
                message: `${result.data.message? result.data.message : "Cannot generate OTP auth"}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot generate OTP auth"}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}

export const fetchVerifyOtp = (data) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const result = await rest.post("/users/verify-otp", data);
            if (result.data && result.data.succeeded) {
                snackActions.snackBar({
                    message: result.data.message? result.data.message : "Successfully verified OTP",
                    options: {
                        variant: 'success'
                    }
                });
                return result.data.result.data;
            }
            snackActions.snackBar({
                message: `${result.data.message? result.data.message : "Cannot verified OTP"}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot verified OTP"}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}

export const fetchCancelAuth = (data) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const res = await rest.post("users/remove-auth", data);
            if (res.data && res.data.succeeded) {
                return res.data.result.data;
            }
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot cancel authentication"}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}

export const sendVerificationMail = (data) => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            const result = await rest.post("/users/send-verification-mail", data);
            if (result.data && result.data.succeeded) {
                snackActions.snackBar({
                    message: result.data.message? result.data.message : "Successfully sent verification mail",
                    options: {
                        variant: 'success'
                    }
                });
                return result.data.result.data;
            }
            snackActions.snackBar({
                message: `${result.data.message? result.data.message : "Cannot send verification mail"}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        } catch (error) {
            snackActions.snackBar({
                message: `${error.message || "Cannot send verification mail"}`,
                options: {
                    variant: 'error'
                }
            });
            return null;
        }
    }
}